import { CourseManifest } from '../../../types/course';
import { getCourseManifestUrl } from '../../../lib/manifest';

export async function fetchCourseManifest(bustCache = false): Promise<CourseManifest> {
  const response = await fetch(getCourseManifestUrl(bustCache), { cache: 'no-store' });
  if (!response.ok) {
    throw new Error('Failed to fetch course manifest');
  }
  const data = await response.json();
  if (!data || typeof data !== 'object' || !Array.isArray(data.courses)) {
    throw new Error('Invalid course manifest response');
  }
  return data as CourseManifest;
}
